

import React, { memo } from 'react';

import { ResourceMembers, ReviewMembers } from '../../../ui-kit';

import DISPLAYED_MEMBERS from '../constants/displayedMembers';

const MEMBERS_IMAGE_SIZE = '40px';









const Members = ({
  displayedMembersType,
  resourceMembers,
  reviewMembers,
  darkMode,
  showCollaborationModal
}) => {
  if (displayedMembersType === DISPLAYED_MEMBERS.RESOURCE) {
    return (
      <ResourceMembers
        showOwnerBadge
        members={resourceMembers}
        imageSize={MEMBERS_IMAGE_SIZE}
        onAddIconClick={showCollaborationModal}
        darkMode={darkMode} />);


  }
  return (
    <ReviewMembers
      members={reviewMembers}
      imageSize={MEMBERS_IMAGE_SIZE} />);


};

export default memo(Members);